var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCartEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 200,
    fill: "none",
    viewBox: "0 0 250 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFF8FF",
    fillRule: "evenodd",
    d: "M131 64a7 7 0 110 14h64a7 7 0 110 14h22a7 7 0 110 14h-19a7 7 0 100 14h6a7 7 0 110 14h-52a7.056 7.056 0 01-1.5-.161 7.056 7.056 0 01-1.5.161H58a7 7 0 110-14H19a7 7 0 110-14h40a7 7 0 100-14H34a7 7 0 110-14h40a7 7 0 110-14h57zm90 56a7 7 0 110 14 7 7 0 010-14z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1E9FF",
    fillRule: "evenodd",
    d: "M91 66h67l-6 9 8 6H89l9-6-7-9z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E90FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M168 145.5h22.428M65 145.5h21.454H65zm-12.872 0H59h-6.872zm143 0H198h-2.872z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M88.006 123.215V83c0-1.657 1.36-3 3.037-3h69.48c1.092 0 1.977.895 1.977 2v73c0 2.209-1.771 4-3.955 4H91.961c-2.184 0-3.955-1.791-3.955-4v-31.785zm0 8.682v-4.503 4.503z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E90FA",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M88.006 131.897v-4.503m0-4.179V83c0-1.657 1.36-3 3.037-3h69.48c1.092 0 1.977.895 1.977 2v73c0 2.209-1.771 4-3.955 4H91.961c-2.184 0-3.955-1.791-3.955-4v-31.785z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E90FA",
    strokeWidth: 2.5,
    d: "M90 80V68c0-1.105.804-2 1.795-2h66.41c.991 0 1.795.895 1.795 2v12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2E90FA",
    strokeWidth: 2.5,
    d: "M108.5 101a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm33 0a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E90FA",
    strokeLinecap: "round",
    strokeWidth: 2.5,
    d: "M141 101c0 8.837-7.163 16-16 16s-16-7.163-16-16M91.061 66.997l7.107 7.015a1 1 0 01-.218 1.587L90 80m69.109-12.93l-6.802 6.937a1 1 0 00.235 1.578L160.636 80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#84CAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M99 41.303l11.1 12.453m41-12.453L140 53.756l11.1-12.453zM125 37v16.756V37z"
  })));
}

export default SvgCartEmptyState;